import styles from "./Filters.module.css";
import {
  CloseOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Dropdown from "../../../employeeTeams/components/Filters/Dropdown";

interface FiltersProps {
  states: string[];
  setSelectedState: (state: string) => void;
  selectedState: string;
  departments: string[];
  setSelectedDepartment: (department: string) => void;
  selectedDepartment: string;
  setSearch: (search: string) => void;
  search: string;
  handleClearFilters: () => void;
  setShowMobileFilters: (show: boolean) => void;
  hasActiveFilters: boolean;
  activeFiltersCount: number;
}

export default function Filters({
  states,
  setSelectedState,
  selectedState,
  departments,
  setSelectedDepartment,
  selectedDepartment,
  setSearch,
  search,
  handleClearFilters,
  setShowMobileFilters,
  hasActiveFilters,
  activeFiltersCount,
}: FiltersProps) {
  return (
    <div className={styles.filters}>
      <div className={styles.searchContainer}>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Procurar por nome ou função"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <SearchOutlined
          style={{ fontSize: "16px", color: "rgba(111, 111, 118, 1)" }}
        />
      </div>
      <div className={styles.mobileFiltersButtonContainer}>
        <button
          className={styles.mobileFiltersButton}
          onClick={() => setShowMobileFilters(true)}
        >
          <FilterOutlined
            style={{ fontSize: "20px", color: "rgb(19, 19, 19)" }}
          />
          {activeFiltersCount > 0 && (
            <span className={styles.mobileFiltersBadge}>
              {activeFiltersCount > 9 ? "9+" : activeFiltersCount}
            </span>
          )}
        </button>
      </div>
      <div className={styles.selectContainer}>
        <Dropdown
          placeholder="Estados"
          options={states}
          selectedValue={selectedState}
          onSelect={setSelectedState}
        />

        <Dropdown
          placeholder="Departamentos"
          options={departments}
          selectedValue={selectedDepartment}
          onSelect={setSelectedDepartment}
        />

        <button
          className={`${styles.clearFiltersButton} ${
            hasActiveFilters ? styles.clearFiltersButtonActive : ""
          }`}
          onClick={handleClearFilters}
          disabled={!hasActiveFilters}
        >
          <CloseOutlined style={{ fontSize: "14px" }} />
          Limpar filtros
        </button>
      </div>
    </div>
  );
}
